'use strict';

var dialog = require('site/dialog'),
	util = require('site/util'),
	linchpin = require('int_googletagmanager/linchpin/dialog'),
	formPrepare = require('site/pages/checkout/formPrepare'),
	reCaptcha = require('int_recaptcha/recaptcha');

/**
 * @private
 * @description removes name attribute of form elements that aren't intended to be sent to SA
 */
var validateFormFields = function ($form) {
	if ($form.valid()) {
		$form.find('#expiry-month').removeAttr('name');
		$form.find('#expiry-year').removeAttr('name');
		$form.find('#bill-to-address-country').removeAttr('name');
		$form.find('#bill-to-address-state-select').removeAttr('name');
		return true;
	} else {
		return false;
	}
};
/*
 * init secure acceptance events
 */

function updateSignature($form, params) {
	var signedFields = $form.find('input[name="signed_field_names"]').val().split(',');
	$.each(signedFields, function (index, value) {
		params[value] = $form.find('input[name="' + value + '"]').val();
	});
	var url = util.appendParamsToUrl(Urls.secureAcceptanceSignature, params);
	$.getJSON(url, function (data) {
		if (data.success) {
			$form.find('input[name="signature"]').val(data.signature);
			$form.submit();
		} else {
			dialog.open({
				url: Urls.requestErrorMessage,
				options: {
					buttons: [
						{
							text: Resources.GOT_IT,
							click: function () {
								$(this).dialog('close');
							}
						}
					],
					title: Resources.SORRY
				}
			});
		}
	});
}

/*
	Update label and icon related to card type, based on option selected
*/
function updateCardTypeIcon(optionData) {
	var $cardTypeVisual = $('.card-type-icon');
	if (!optionData) {
		return $cardTypeVisual.hide();
	}
	$cardTypeVisual.find('img')
		.attr('src', optionData.imgURL)
		.attr('title', optionData.name)
		.attr('alt', optionData.name).show();
	$cardTypeVisual.find('span')
		.text(optionData.name)
		.hide();
	// when no image availbe leave just text label
	if (!optionData.imgURL) {
		$cardTypeVisual.find('span').show();
		$cardTypeVisual.find('img').hide();
	}
	$cardTypeVisual.show();
}

/*
	Method format card number as following
	input number should consist of numbers only
	**** **** **** ****
*/
function formatCardNumber(value) {
	var result = '';
	for (var i = 0; i < value.length; i++) {
		if (i % 4 == 0) {
			result += ' ';
		}
		result += value[i];
	}

	return result.trim();
}

function initSecureAcceptance (data) {
	var submitHandler = function (event) {
		// handler can be called from recaptcha or with button submit so need to check params
		// once passed first time, value of input is set, so we should handle it with another try
		if (event && event.type) {
			event.preventDefault();
		} else {
			$('#secure-acceptance-submit').on('click', submitHandler);
		}
		var $secureAcceptanceForm = $('#secure-acceptance-form');
		if (!validateFormFields($secureAcceptanceForm)) {
			return false;
		}
		if ($secureAcceptanceForm.find('.bill-to-address-state:visible').length > 0) {
			$secureAcceptanceForm.find('input[name="bill_to_address_state"]').val($('.bill-to-address-state:visible').val());
		}

		$('input[name="merchant_defined_data9"]').val($secureAcceptanceForm.find('input[name="card_number"]').val().substr(0, 2));
	
		var signedFields = $secureAcceptanceForm.find('input[name="signed_field_names"]').val().split(','),
			params = {};
		/* jshint ignore:start */
		if (data && data.addNewCard) {
			params['addNewCard'] = data.addNewCard;
		}
		params['merchant_defined_data8'] = $secureAcceptanceForm.find('input[name="merchant_defined_data8"]').val();
		params['csrf_token'] = $secureAcceptanceForm.find('input[name="csrf_token"]').val();
		params['g-recaptcha-response'] = $secureAcceptanceForm.find('.g-recaptcha-response').val();
		/* jshint ignore:end */
		updateSignature($secureAcceptanceForm, params);
		// GTM Linchpin analytics
		linchpin.addNewCard();
	};

	if (!reCaptcha.initRecaptchaOnForm('#secure-acceptance-form', submitHandler)) {
		$('#secure-acceptance-submit').on('click', submitHandler);
	}
	$('.pay-with-saved-card .continue').on('click', function (e) {
		e.preventDefault();
		var $form = $(this).parents('form');
		if (!$form.valid()) {
			return false;
		}
		var populateValues = ['card_cvn', 'payment_token', 'card_expiry_date', 'card_type', 'signature'];
		var $updateTokenForm = $('#secure-acceptance-update-token-form');
		for (var i = 0; i < populateValues.length; i++) {
			var name = populateValues[i];
			var selectedCardValue = $form.find('[name="' + name + '"]').val();
			$updateTokenForm.find('[name="' + name + '"]').val(selectedCardValue);
		}
		$updateTokenForm.submit();
	});

	$('#expiry-month, #expiry-year').on('change', function () {
		$('input[name="card_expiry_date"]').val($('#expiry-month').val() + '-' + $('#expiry-year').val());
	});
	$('input[name="save_card"]').on('change', function () {
		$('input[name="merchant_defined_data6"]').val(this.checked);
		const $formSA = $('#secure-acceptance-form');
		const isSAEmbedded = $formSA.data('embedded');
		if (isSAEmbedded) {
			$(document).trigger('reinitforsavecard');
		}

	});
	$('#bill-to-address-country').on('change', function () {
		var countryCode = $('#bill-to-address-country').val();
		$('input[name="bill_to_address_country"]').val(countryCode);
		updateStateField(countryCode);
		updatePostFieldPlaceholder(countryCode);
	});
	
	
	// collect card types data list
	var cardTypesData = [];
	$('[name="card_type"] option').each(function() {
		var optionData = $(this).data();
		if (!optionData.pattern) {
			return;
		}

		cardTypesData.push({
			name: optionData.type,
			rule: new RegExp(optionData.pattern),
			imgURL: optionData.image,
			element: this
		});
	});

	// if data available to validate card types, hide type field
	window.console.debug('cardTypesData', cardTypesData);
	if (cardTypesData.length) {
		$('[name="card_type"]').closest('.form-row').addClass('visually-hidden');
	}

	// handle card type auto populate and change
	$('[name="card_type"]').on('change', function () {
		// update type icon or text?
		var selectedOption = $(this).find('option:selected').get(0);
		for (var i = 0, cardTypeData; i < cardTypesData.length; i++) {
			cardTypeData = cardTypesData[i];
			if (cardTypeData.element == selectedOption) {
				updateCardTypeIcon(cardTypeData);
				return;
			}
		}
	});

	// when card number updated attempt to check card type
	// if after chaning card type cannot be determined, show card type
	$('[name="card_number"]').on('keyup paste change', function (e) {
		// number without spaces to simplify rules
		var cardNumVal = $(this).val().replace(/\s+/g, '');
		if (cardNumVal.length < 1 || !cardTypesData.length) {
			return;
		}
		/* format number not applicable, as field type is number
		if (e.type == 'change' || e.type == 'paste') {
			$(this).val(formatCardNumber(cardNumVal));
		}*/
		var isFinal = cardNumVal.length > 6;
		for (var i = 0, typeData; i < cardTypesData.length; i++) {
			typeData = cardTypesData[i];
			if (typeData.rule.test(cardNumVal)) {
				$('[name="card_type"]').val(typeData.element.value).change();
				$('.card-type-help').addClass('visually-hidden');
				return;
			}
		}
		// nothing found, but number entered - show help area
		if (isFinal) {
			updateCardTypeIcon(); // reset icon
			$('.card-type-help').removeClass('visually-hidden');
		}
	});

	formPrepare.init({
		continueSelector: '#secure-acceptance-submit',
		formSelector: '#secure-acceptance-form',
		replaceInvalidInput: true,
		keyup: false,
		autofillValidate: true
	});

	if ($('.tasting-club-update').length === 0) {
		updateStateField($('#bill-to-address-country').val());
		updatePostFieldPlaceholder($('#bill-to-address-country').val());
	}

}
/**
 * @private
 * @description revalidate invalid field once it becomes visible
 */
var revalidateField = function ($formRow) {
	if ($formRow.find('.error-msg').length > 0) {
		$('#secure-acceptance-form').validate()
		.element($formRow.find('[name$="county_field"]'));
	}
};
function updateStateField (countryCode) {
	var $stateSelectFormRow = $('#secure-acceptance-form .state-select'),
		$stateInputFormRow = $('#secure-acceptance-form .state-input'),
		countryObj = Countries[countryCode];

	if (countryObj && Countries[countryCode].regions) {
		$stateSelectFormRow.show();
		revalidateField($stateSelectFormRow);
		$stateInputFormRow.hide();
		$stateInputFormRow.find('[name$="county_field"]').rules("add", {required: true});
		setStateOptions(countryObj);
	} else {
		$stateInputFormRow.show();
		revalidateField($stateInputFormRow);
		$stateSelectFormRow.hide();
		$stateInputFormRow.find('[name$="county_field"]').rules("remove", "required");
	}
}

function setStateOptions(countryObj) {
	var statesOptions = [];
	statesOptions.push('<option value="">' + countryObj.regionLabel + '</option>');
	var selectedState = $('input[name="bill_to_address_state"]').val();
	for (var r in countryObj.regions) {
		if (selectedState === r) {
			statesOptions.push('<option selected="selected" value="' +  r + '">' + countryObj.regions[r] + '</option>');
		} else {
			statesOptions.push('<option value="' +  r + '">' + countryObj.regions[r] + '</option>');
		}
	}
	$('#bill-to-address-state-select').html(statesOptions);
	$('#bill-to-address-state-select').trigger('change');
}

function updatePostFieldPlaceholder(countryCode) {
	var countryObj =  Countries[countryCode],
		$postField = $('#secure-acceptance-form').find('[name$="postal_code"]');

	if (countryObj && countryCode === 'GB' && countryObj.postalLabel) {
		$postField.attr('placeholder', countryObj.postalLabel);
	} else {
		$postField.attr('placeholder', Resources.ZIPCODE_UNIVERSAL_LABEL);
	}
}
var sa = {
	init: function (params) {
		initSecureAcceptance(params);
	}
};

module.exports = sa;
